/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export const tableWrapper = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
`

export const toolbarLeft = css`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`

export const searchInput = css`
  width: 280px;
`

export const categoryFilter = css`
  width: 280px;
`

export const tableContainer = css`
  overflow-x: auto;
  overflow-y: visible;
`

export const tableWrapperBordered = css`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
  overflow: hidden;
`

export const tableHeaderScroller = css`
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid rgba(224, 224, 224, 1);

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`

export const tableBodyScroller = css`
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 380px);
`

export const headerCell = css`
  min-width: 120px;
`

export const emptyRow = css`
  padding: 48px 0;
  text-align: center;
`
